(function () {
  'use strict';

  var CARD_SELECTOR = '.products .box.product, .products-list .box.product, .search-results .box.product, .collection .box.product, .product-card, .product-item, [data-product-handle]';
  var IMAGE_SLOT_SELECTOR = '.bioss-card-image-loader.has-bioss-card-image, .bioss-card-image-injected.has-bioss-card-image, .bioss-card-image-loader, .bioss-card-image-injected';
  var MAX_CARDS_PER_SCAN = 120;
  var RESCAN_DELAY_MS = 200;
  var PERIODIC_RESCAN_MS = 2200;
  var PERIODIC_RESCAN_LIMIT_MS = 120000;
  var PROMOTION_RATE = 0.75;
  var CONJUGATION_SUFFIXES = [
    'bf350', 'bf405', 'bf488', 'bf555', 'bf594', 'bf647', 'bf680', 'bf750',
    'fitc', 'pe', 'apc', 'percp', 'cy3', 'cy5', 'cy5-5', 'cy7',
    'pe-cy5', 'pe-cy5-5', 'pe-cy7', 'apc-cy7', 'apc-cy5-5', 'percp-cy5-5',
    'biotin', 'hrp', 'rbitc'
  ];
  var startedAt = Date.now();
  var scanTimer = null;
  var productRequests = {};

  function normalizeText(text) {
    return (text || '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  }

  function endsWithApprovedConjugation(value) {
    var key = String(value || '').toLowerCase().replace(/[?#].*$/, '').replace(/\/$/, '');
    if (!key) return false;
    for (var i = 0; i < CONJUGATION_SUFFIXES.length; i += 1) {
      if (key.slice(-CONJUGATION_SUFFIXES[i].length - 1) === '-' + CONJUGATION_SUFFIXES[i]) return true;
    }
    return false;
  }

  function hasRecombinantPromotionMarker(product) {
    if (window.location.pathname.indexOf('/collections/recombinant-proteins') !== -1) return true;

    var tags = product && product.tags;
    if (Array.isArray(tags)) tags = tags.join('|');
    tags = String(tags || '').toLowerCase();
    return tags.indexOf('recombinant-proteins') !== -1 || tags.indexOf('recombinant proteins') !== -1;
  }

  function isPromotionEligible(card, product, productUrl) {
    if (card && card.getAttribute('data-bioss-promo') === 'true') return true;
    return hasRecombinantPromotionMarker(product) ||
      endsWithApprovedConjugation(product && product.handle) ||
      endsWithApprovedConjugation(productUrl);
  }

  function getProductUrlFromCard(card) {
    if (!card) return null;

    var direct = card.getAttribute('data-product-url') || card.getAttribute('data-url') || '';
    if (direct && direct.indexOf('/products/') !== -1) return direct.split('#')[0];

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (handle) return '/products/' + handle;

    var slot = card.querySelector('[data-product-url*="/products/"], [data-images-endpoint*="/products/"]');
    if (slot) {
      direct = slot.getAttribute('data-product-url') || slot.getAttribute('data-images-endpoint') || '';
      if (direct.indexOf('/products/') !== -1) return direct.split('?')[0].split('#')[0];
    }

    var link = card.querySelector('a.product-title[href], header a[href*="/products/"], h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]');
    if (!link) return null;

    var href = link.getAttribute('href') || '';
    if (!href || href.indexOf('/products/') === -1) return null;
    return href.split('#')[0];
  }

  function getProductTitleFromCard(card) {
    var title = card && (card.getAttribute('data-product-title') || card.getAttribute('data-title'));
    if (title) return normalizeText(title);
    var titleEl = card && card.querySelector('a.product-title, header a[href*="/products/"], h1 a, h2 a, h3 a');
    return titleEl ? normalizeText(titleEl.textContent || titleEl.getAttribute('title') || '') : '';
  }

  function productJsonUrl(productUrl) {
    if (!productUrl) return null;
    var match = productUrl.match(/\/products\/([^/?#]+)/i);
    if (!match || !match[1]) return null;
    return '/products/' + match[1] + '.js?bioss_card_variants_v=32';
  }

  function fetchProduct(jsonUrl) {
    if (!jsonUrl || !window.fetch) return Promise.resolve(null);
    if (productRequests[jsonUrl]) return productRequests[jsonUrl];

    productRequests[jsonUrl] = window.fetch(jsonUrl, {
      credentials: 'same-origin',
      cache: 'no-cache'
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        return product || null;
      })
      .catch(function () { return null; });

    return productRequests[jsonUrl];
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseFloat(cents);
    if (typeof cents !== 'number' || isNaN(cents)) return '';

    var formatted = '';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        formatted = window.Shopify.formatMoney(cents, window.Currency && window.Currency.format ? window.Currency.format : '${{amount}}');
      } else if (window.BCCShopify && typeof window.BCCShopify.formatMoney === 'function') {
        formatted = window.BCCShopify.formatMoney(cents);
      }
    } catch (error) {}

    if (!formatted) {
      formatted = '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
    }

    return String(formatted)
      .replace(/\$\s+/g, '$')
      .replace(/\.00(?!\d)/g, '')
      .trim();
  }

  function normalizeVariantSize(title, option1) {
    var size = normalizeText(title || option1 || '');
    if (!size || /^default title$/i.test(size)) return '';
    size = size.replace(/\b([0-9]+(?:\.[0-9]+)?)\s*u[lL]\b/g, '$1µL');
    size = size.replace(/\b([0-9]+(?:\.[0-9]+)?)\s*µl\b/gi, '$1µL');
    size = size.replace(/\b([0-9]+(?:\.[0-9]+)?)\s*ml\b/gi, '$1mL');
    size = size.replace(/\b([0-9]+(?:\.[0-9]+)?)\s*mg\b/gi, '$1mg');
    size = size.replace(/\s*\/\s*/g, ' / ');
    return size;
  }

  function availableVariants(product) {
    if (!product || !Array.isArray(product.variants)) return [];
    return product.variants.filter(function (variant) {
      if (!variant) return false;
      if (variant.available === false) return false;
      if (variant.price === null || typeof variant.price === 'undefined') return false;
      return true;
    });
  }

  function createVariantOption(variant, index, productUrl, promotionEligible) {
    var href = productUrl || '#';
    if (variant && variant.id && href !== '#') {
      href = href.split('?')[0].split('#')[0] + '?variant=' + encodeURIComponent(variant.id);
    }

    var item = document.createElement('a');
    item.className = 'bioss-card-variant-option' + (index === 0 ? ' is-primary' : '');
    item.href = href;
    item.setAttribute('aria-label', 'View ' + normalizeVariantSize(variant.title, variant.option1) + ' option');

    var dot = document.createElement('span');
    dot.className = 'bioss-card-variant-dot';

    var text = document.createElement('span');
    text.className = 'bioss-card-variant-text';

    var price = document.createElement('span');
    price.className = 'bioss-card-variant-price';
    var compareAtPrice = Number(variant.compare_at_price || 0);
    var currentPrice = Number(variant.price || 0);
    var hasStoredSale = compareAtPrice > currentPrice;
    var hasPromotionalPrice = promotionEligible && !hasStoredSale;
    var isDiscounted = hasStoredSale || hasPromotionalPrice;

    if (isDiscounted) {
      item.classList.add('is-sale');
      price.classList.add('bioss-card-variant-price--sale');

      var salePrice = document.createElement('span');
      salePrice.className = 'bioss-card-variant-price__sale';
      var displayPrice = hasPromotionalPrice ? Math.round(currentPrice * PROMOTION_RATE) : currentPrice;
      salePrice.textContent = formatMoney(displayPrice);

      var listPrice = document.createElement('span');
      listPrice.className = 'bioss-card-variant-price__list';
      var listPriceValue = hasPromotionalPrice ? currentPrice : compareAtPrice;
      listPrice.textContent = formatMoney(listPriceValue);
      listPrice.setAttribute('aria-label', 'List price ' + formatMoney(listPriceValue));

      var validity = document.createElement('span');
      validity.className = 'bioss-card-variant-price__validity';
      validity.textContent = 'Valid Till 12/31/26';

      price.appendChild(salePrice);
      price.appendChild(listPrice);
    } else {
      price.textContent = formatMoney(currentPrice);
    }

    var size = document.createElement('span');
    size.className = 'bioss-card-variant-size';
    var sizeText = normalizeVariantSize(variant.title, variant.option1);
    size.textContent = sizeText || 'Available';

    text.appendChild(price);
    text.appendChild(size);
    if (isDiscounted) text.appendChild(validity);
    item.appendChild(dot);
    item.appendChild(text);
    return item;
  }

  function cartIconSvg() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'bioss-card-add-cart-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '21');
    svg.setAttribute('height', '21');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    var cart = document.createElementNS(svgNS, 'path');
    cart.setAttribute('d', 'M7.2 18.2c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8S9 21 9 20s-.8-1.8-1.8-1.8Zm9.3 0c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8ZM6.5 6.2h13.8l-1.7 7.2c-.2.9-1 1.5-1.9 1.5H8.2c-.9 0-1.7-.6-1.9-1.5L4.6 3.7H2.2V2h3.7l.6 4.2Zm.3 1.7 1 5.1c.1.2.2.4.5.4h8.4c.2 0 .4-.2.5-.4l1.2-5.1H6.8Z');
    cart.setAttribute('fill', 'currentColor');

    var plusV = document.createElementNS(svgNS, 'path');
    plusV.setAttribute('d', 'M13.1 9.1h-1.7V7.4H9.9v1.7H8.2v1.5h1.7v1.7h1.5v-1.7h1.7V9.1Z');
    plusV.setAttribute('fill', 'currentColor');

    svg.appendChild(cart);
    svg.appendChild(plusV);
    return svg;
  }

  function getCartCountBubble() {
    return document.querySelector('#CartCount, [data-cart-count], .cart-count, .cart-item-count');
  }

  function bumpCartCount() {
    var bubble = getCartCountBubble();
    if (!bubble) return;
    var current = parseInt((bubble.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(current)) current = 0;
    bubble.textContent = String(current + 1);
  }

  function getCartImageFromButton(button) {
    var card = button && button.closest ? button.closest('.box.product, .product-card, [data-product-url]') : null;
    if (!card) return '';

    var dataImage = card.getAttribute('data-bioss-cart-image-src');
    if (dataImage) return dataImage;

    var image = card.querySelector('[data-bioss-cart-image-src], .bioss-card-image-img, .bioss-card-image-carousel__image, img[src]');
    if (!image) return '';

    return image.getAttribute('data-bioss-cart-image-src') || image.getAttribute('src') || image.src || '';
  }

  function postAddToCart(variantId, button) {
    if (!variantId || !button) return;

    var oldLabel = button.getAttribute('aria-label') || 'Add to cart';
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    var payload = { id: variantId, quantity: 1 };
    var cartImage = getCartImageFromButton(button);

    if (cartImage) {
      payload.properties = {
        _bioss_cart_image: cartImage
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.setAttribute('aria-label', 'Added to cart');
      bumpCartCount();
      window.setTimeout(function () {
        button.classList.remove('is-added');
        button.setAttribute('aria-label', oldLabel);
        button.removeAttribute('aria-busy');
      }, 1600);
    }).catch(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      button.setAttribute('aria-label', 'Could not add to cart');
      window.setTimeout(function () {
        button.classList.remove('is-error');
        button.setAttribute('aria-label', oldLabel);
        button.removeAttribute('aria-busy');
      }, 1800);
    });
  }

  function createAddToCartButton(variant) {
    if (!variant || !variant.id) return null;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bioss-card-add-cart-button';
    button.setAttribute('aria-label', 'Add ' + normalizeVariantSize(variant.title, variant.option1) + ' to cart');
    button.setAttribute('data-bioss-card-add-cart', String(variant.id));

    button.appendChild(cartIconSvg());

    var label = document.createElement('span');
    label.className = 'bioss-card-add-cart-label';
    label.textContent = 'Add to Cart';
    button.appendChild(label);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      postAddToCart(variant.id, button);
    });

    return button;
  }

  function renderVariantPricing(slot, product, productUrl, promotionEligible) {
    if (!slot || !product) return false;

    var existing = slot.querySelector('.bioss-card-variant-pricing');
    if (existing) existing.parentNode.removeChild(existing);

    var variants = availableVariants(product);
    if (!variants.length) return false;

    var wrap = document.createElement('div');
    wrap.className = 'bioss-card-variant-pricing';
    wrap.setAttribute('data-bioss-card-variant-count', String(variants.length));

    var visibleLimit = variants.length > 4 ? 3 : variants.length;
    for (var i = 0; i < visibleLimit; i += 1) {
      wrap.appendChild(createVariantOption(variants[i], i, productUrl, promotionEligible));
    }

    if (variants.length > visibleLimit) {
      var more = document.createElement('a');
      more.className = 'bioss-card-variant-more';
      more.href = productUrl || '#';
      more.textContent = '+' + (variants.length - visibleLimit) + ' sizes';
      wrap.appendChild(more);
    }

    var addButton = createAddToCartButton(variants[0]);
    if (addButton) wrap.appendChild(addButton);

    slot.appendChild(wrap);
    slot.classList.add('has-bioss-card-variant-pricing');
    slot.setAttribute('aria-hidden', 'false');
    var figure = slot.closest('figure');
    if (figure) figure.classList.add('has-bioss-card-pricing');
    return true;
  }

  function findVariantSlot(card) {
    if (!card) return null;

    var imageSlot = card.querySelector('.bioss-card-image-loader.has-bioss-card-image, .bioss-card-image-injected.has-bioss-card-image');
    if (imageSlot) return imageSlot;

    imageSlot = card.querySelector(IMAGE_SLOT_SELECTOR);
    if (imageSlot) return imageSlot;

    var figure = card.querySelector('figure') || card;
    var slot = document.createElement('div');
    slot.className = 'bioss-card-image-injected';
    slot.setAttribute('data-bioss-product-card-image', 'injected');
    slot.setAttribute('data-product-url', getProductUrlFromCard(card) || '');
    slot.setAttribute('data-product-title', getProductTitleFromCard(card));
    figure.insertBefore(slot, figure.firstChild);
    return slot;
  }

  function processCard(card) {
    if (!card || card.getAttribute('data-bioss-card-variants-loaded') === 'true') return;

    var productUrl = getProductUrlFromCard(card);
    var jsonUrl = productJsonUrl(productUrl);
    if (!jsonUrl) return;

    var slot = findVariantSlot(card);
    if (!slot) return;

    card.setAttribute('data-bioss-card-variants-loaded', 'true');
    fetchProduct(jsonUrl).then(function (product) {
      if (!product) {
        card.removeAttribute('data-bioss-card-variants-loaded');
        return;
      }
      renderVariantPricing(findVariantSlot(card), product, productUrl, isPromotionEligible(card, product, productUrl));
    });
  }

  function scanCards() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    var processed = 0;
    for (var i = 0; i < cards.length; i += 1) {
      processCard(cards[i]);
      processed += 1;
      if (processed >= MAX_CARDS_PER_SCAN) break;
    }
  }

  function scheduleScan() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scanCards();
    }, RESCAN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      scheduleScan();
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', scheduleScan);
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.searchspring-facets, .filter-menu, .collection-sidebar, .pagination')) {
      window.setTimeout(scheduleScan, 300);
      window.setTimeout(scheduleScan, 900);
      window.setTimeout(scheduleScan, 1800);
    }
  });

  var periodic = window.setInterval(function () {
    if (Date.now() - startedAt > PERIODIC_RESCAN_LIMIT_MS) {
      window.clearInterval(periodic);
      return;
    }
    scheduleScan();
  }, PERIODIC_RESCAN_MS);
})();
